import { createSlice } from "@reduxjs/toolkit";
const initialUrlState = { urlData: {} };

export const urlSlice = createSlice({
  name: "url",
  initialState: initialUrlState,
  reducers: {
    setUrlState(state, action) {
      state.urlData = { ...state.urlData, ...action.payload };
    },
    resetUrlState(state) {
     return initialUrlState;
    },
    updateUrlState(state, action) {
      state.urlData = { ...state.urlData, ...action.payload };
    },
  },
});